import { css } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'

export const style = css`
  :host {
    display: block;
  }

  .hidden-fields {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing03};
  }
`
